import { Alert, Flex, List, Modal, Typography } from 'antd';
import { DocumentItem } from 'components/documents/document-item';
import styles from './invoice-documents-modal.module.scss';
import type { IInvoiceDocumentsModalProps } from './types';

export const InvoiceDocumentsModal = (props: IInvoiceDocumentsModalProps) => {
  const { invoice, isOpen, isLoading, isError, documents, onClose } = props;

  const related = invoice.order || invoice.trip || invoice.warehouseTask;

  return (
    <Modal
      open={isOpen}
      footer={null}
      width={680}
      title={
        <Flex vertical>
          <span>Documents</span>
          <Typography.Text type='secondary'>
            {related && <Typography.Text strong>{related.compositeId}</Typography.Text>}
            {' - '}Invoice #{invoice.id} · {invoice.client.shortName || invoice.client.name}
          </Typography.Text>
        </Flex>
      }
      onCancel={onClose}>
      {isError ? (
        <Alert type='error' message='Unable to load documents. Please try again.' />
      ) : (
        <List
          className={styles.documentsList}
          size='small'
          itemLayout='horizontal'
          loading={isLoading}
          dataSource={documents}
          locale={{ emptyText: 'No documents were found.' }}
          renderItem={(document) => <DocumentItem key={document.id} document={document} readOnly />}
        />
      )}
    </Modal>
  );
};
